"use client"
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "../ui/sheet";
import { useSidebarStore } from "@/zustand-hooks/sidebar";
import { useUser } from "@/zustand-hooks/user-hook";
import { useTranslations } from "next-intl";
import Image from "next/image";
import BalanceMobile from "./BalanceMobile/BalanceMobile";
import NotificationsMobile from "./NotificationsMobile";
import { SetStateAction } from "react";
import { NotificationType } from "@/react-queries/queries/notifications/types";
import ThemeToggleMobile from "./ThemeToggleMobile";
import { Link } from "@/i18n/routing";
import { Button } from "../ui/button";
import { ArrowRight, LogOutIcon, User } from "lucide-react";
import ChangeLangMobile from "./ChangeLangMobile";
import { useRouter } from "next/navigation";
import useIsMounted from "@/hooks/useIsMounted";

const HeaderUserSidebar = ({
  setNotification,
}: {
  setNotification: React.Dispatch<SetStateAction<NotificationType | undefined>>;
}) => {
  const isMounted = useIsMounted()

  const { user, logOutUser } = useUser();
  const { toggleUserSidebarCollapsed, isUserCollapsed } = useSidebarStore();
  const t = useTranslations("Header.user");
  const router = useRouter();


  if (!isMounted) return null

  return (
    <Sheet
      open={isUserCollapsed}
      onOpenChange={() => toggleUserSidebarCollapsed()}
    >
      {/* Чисто чтоб предупреждение не выбивало в консоли */}
      <SheetDescription></SheetDescription>
      <SheetContent className="w-full overflow-y-auto" side={"right"}>
        <SheetHeader>
          <SheetTitle className="mb-6">
            <div className="flex w-full items-center justify-start gap-2">
              <Image
                alt=""
                src={"/assets/images/default_avatar.png"}
                width={40}
                height={40}
              />
              {user?.first_name} {user?.last_name}
            </div>
          </SheetTitle>
        </SheetHeader>
        <hr className="border-slate-200 dark:border-slate-500 mb-4" />
        <ul className="flex overflow-y-auto flex-col gap-4">
          <ChangeLangMobile />
          <ThemeToggleMobile />
          <BalanceMobile />
          <NotificationsMobile setNotification={setNotification} />
          <Link
            className="transition-transform overflow-hidden rounded-sm w-full bg-white dark:bg-slate-800 border border-slate-200 dark:border-none"
            href={"/profile"}
            onClick={toggleUserSidebarCollapsed}
          >
            <Button className="w-full items-center justify-start gap-2 p-4 font-bold text-md h-full">
              <User />
              {t("profile")}
              <ArrowRight className="ml-auto" />
            </Button>
          </Link>
          <Button
            className="w-full items-center justify-start gap-2 p-4 font-bold text-md h-full"
            onClick={() => {
              toggleUserSidebarCollapsed();
              logOutUser();
              setTimeout(()=> {
                router.refresh()
              }, 1000)
            }}
          >
            <LogOutIcon />
            {t("logout")}
          </Button>
        </ul>
      </SheetContent>
    </Sheet>
  );
};

export default HeaderUserSidebar;
